import React from 'react';
import Image from 'next/legacy/image';

import { ITestimonialFields } from '../../../types/contentful';

import quoteMarks from '@/images/quote-marks.svg';

interface Props extends ITestimonialFields {
  color: string;
}

const BRAND_COLOR = '#80D6B0'; // theme.color.brand (spearmint)

export function Testimonial({ name, body, color }: Props) {
  return (
    <div
      className="testimonial"
      style={{ backgroundColor: color || BRAND_COLOR }}
      data-testid="testimonial-block"
    >
      <div className="hidden max-h-full w-[4.125rem] desktop:block">
        <Image src={quoteMarks} alt="Quote Marks" />
      </div>

      <blockquote className="m-0 p-0">
        <p className="testimonial-body">{body}</p>
      </blockquote>

      <p className="text-[1rem] font-semibold desktop:text-[1.125rem]">
        {name}
      </p>
    </div>
  );
}
